// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordModal_root__1S9Ix"};